import { ModuleRendering } from '@frontend/common-types';
import { ModuleType } from '@frontend/module/types';

export const useModuleController = <TModule extends ModuleRendering = ModuleRendering>(
    module: TModule,
    scale: number,
    offsetX: number,
    offsetY: number,
    onModuleClick?: (module: TModule) => void,
    onModuleExpand?: (spotId: string, moduleId: string) => void
) => {
    const isCarousel = module.type === ModuleType.carousel;
    const doorCount = module.doors ?? 0;

    const handleModuleClick = () => {
        if (onModuleClick) {
            onModuleClick(module);
        }
    };

    const handleCarouselClick = () => {
        if (onModuleExpand) {
            onModuleExpand(module.spot_id, module.id);
        }
        handleModuleClick();
    };

    const handleLabelClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onModuleExpand) {
            onModuleExpand(module.spot_id, module.id);
        }
    };

    const moduleLeft = (module.location?.x ?? 0) * scale + offsetX;
    const moduleWidth = (module.dimension?.width ?? 0) * scale;
    const moduleHeight = (module.dimension?.height ?? 0) * scale;
    const moduleTop = -((module.location?.y ?? 0) + (module.dimension?.height ?? 0)) * scale + offsetY;

    const doorGap = 4;
    const doorWidth = 75;
    const doorHeight = isCarousel && doorCount > 0 ? (moduleHeight - doorGap * (doorCount - 1)) / doorCount : 0;
    const doorColumnLeft = moduleLeft + (moduleWidth - doorWidth) / 2;

    return {
        isCarousel,
        doorCount,
        handleModuleClick,
        handleCarouselClick,
        handleLabelClick,
        moduleLeft,
        moduleWidth,
        moduleHeight,
        moduleTop,
        doorWidth,
        doorHeight,
        doorColumnLeft
    };
};
